<script lang="ts">
  import { getContext, type Snippet } from 'svelte'

  type Props = {
    children: Snippet
    value: string
  }

  const { children, value }: Props = $props()

  const { selected } = getContext('tabs') as TabContext

  function handleClick() {
    selected.set(value)
  }
</script>

<button
  class="container"
  data-active={$selected === value}
  onclick={handleClick}
>
  {@render children()}
</button>

<style lang="scss">
  .container {
    font-weight: 600;
    font-size: 0.75rem;
    line-height: 100%;
    vertical-align: middle;
    border: none;
    min-height: 1.5rem;
    height: fit-content;
    padding: 0 0.5rem;
    border-radius: 0.25rem;
    cursor: pointer;
    background-color: var(--tab-button-background);
    color: var(--tab-button-foreground);

    &:hover {
      background-color: var(--tab-button-hover-background);
    }

    &:focus-visible {
      outline: 1px solid var(--stroke);
      outline-offset: 2px;
    }

    &[data-active='true'] {
      background-color: var(--tab-button-active-background);
      color: var(--tab-button-active-foreground);
    }
  }
</style>
